module.exports = __webpack_public_path__ + "media/src/assets/images/booking-details/breakfast-2d6a561420abc6326045a8de72f860fd.png";